var map = {
	"./abw.svg": 79781,
	"./afg.svg": 80777,
	"./ago.svg": 48422,
	"./aia.svg": 5670,
	"./ala.svg": 19009,
	"./alb.svg": 13970,
	"./and.svg": 98610,
	"./are.svg": 2871,
	"./arg.svg": 14469,
	"./arm.svg": 69599,
	"./asm.svg": 9680,
	"./ata.svg": 377,
	"./atf.svg": 25142,
	"./atg.svg": 12263,
	"./aus.svg": 15720,
	"./aut.svg": 18119,
	"./aze.svg": 8495,
	"./bdi.svg": 81978,
	"./bel.svg": 69556,
	"./ben.svg": 1526,
	"./bes.svg": 31923,
	"./bfa.svg": 90520,
	"./bgd.svg": 96018,
	"./bgr.svg": 40972,
	"./bhr.svg": 44221,
	"./bhs.svg": 32028,
	"./bih.svg": 49588,
	"./blm.svg": 82462,
	"./blr.svg": 18633,
	"./blz.svg": 90897,
	"./bmu.svg": 62261,
	"./bol.svg": 30882,
	"./bra.svg": 83148,
	"./brb.svg": 62175,
	"./brn.svg": 10027,
	"./btn.svg": 8437,
	"./bvt.svg": 86725,
	"./bwa.svg": 73535,
	"./caf.svg": 42311,
	"./can.svg": 62863,
	"./cat.svg": 21061,
	"./cck.svg": 45544,
	"./che.svg": 76411,
	"./chl.svg": 68786,
	"./chn.svg": 52080,
	"./civ.svg": 40319,
	"./cmr.svg": 20727,
	"./cod.svg": 88003,
	"./cog.svg": 98608,
	"./cok.svg": 14612,
	"./col.svg": 92315,
	"./com.svg": 23498,
	"./cpv.svg": 88448,
	"./cri.svg": 19545,
	"./cub.svg": 86287,
	"./cuw.svg": 42370,
	"./cxr.svg": 64052,
	"./cym.svg": 63108,
	"./cyp.svg": 47969,
	"./cze.svg": 18277,
	"./deu.svg": 33215,
	"./dji.svg": 79138,
	"./dma.svg": 13611,
	"./dnk.svg": 39956,
	"./dom.svg": 77321,
	"./dza.svg": 93290,
	"./ecu.svg": 84916,
	"./egy.svg": 71639,
	"./eng.svg": 57045,
	"./eri.svg": 27607,
	"./esh.svg": 87745,
	"./esp.svg": 55625,
	"./est.svg": 48613,
	"./eth.svg": 5836,
	"./eun.svg": 29857,
	"./fin.svg": 68998,
	"./fji.svg": 29136,
	"./flk.svg": 44316,
	"./fra.svg": 94816,
	"./fro.svg": 82758,
	"./fsm.svg": 20211,
	"./gab.svg": 34159,
	"./gbr.svg": 51462,
	"./geo.svg": 3534,
	"./ggy.svg": 21034,
	"./gha.svg": 96731,
	"./gib.svg": 5239,
	"./gin.svg": 97715,
	"./glp.svg": 39446,
	"./gmb.svg": 54131,
	"./gnb.svg": 34170,
	"./gnq.svg": 60665,
	"./grc.svg": 75127,
	"./grd.svg": 30200,
	"./grl.svg": 39296,
	"./gtm.svg": 40715,
	"./guf.svg": 21415,
	"./gum.svg": 31708,
	"./guy.svg": 93792,
	"./hkg.svg": 26387,
	"./hmd.svg": 88906,
	"./hnd.svg": 28503,
	"./hrv.svg": 88825,
	"./hti.svg": 55712,
	"./hun.svg": 18024,
	"./idn.svg": 80534,
	"./imn.svg": 28701,
	"./ind.svg": 83194,
	"./iot.svg": 80669,
	"./irl.svg": 24822,
	"./irn.svg": 24084,
	"./irq.svg": 55219,
	"./isl.svg": 46089,
	"./isr.svg": 31023,
	"./ita.svg": 37521,
	"./jam.svg": 53545,
	"./jey.svg": 38673,
	"./jor.svg": 94684,
	"./jpn.svg": 61065,
	"./kaz.svg": 66235,
	"./ken.svg": 79859,
	"./kgz.svg": 85685,
	"./khm.svg": 65051,
	"./kir.svg": 38843,
	"./kna.svg": 46709,
	"./kor.svg": 69973,
	"./kos.svg": 97364,
	"./kwt.svg": 39635,
	"./lao.svg": 30481,
	"./lbn.svg": 92189,
	"./lbr.svg": 64681,
	"./lby.svg": 5698,
	"./lca.svg": 17097,
	"./lie.svg": 71235,
	"./lka.svg": 28289,
	"./lso.svg": 46095,
	"./ltu.svg": 26136,
	"./lux.svg": 4434,
	"./lva.svg": 41982,
	"./mac.svg": 64664,
	"./maf.svg": 96069,
	"./mar.svg": 24729,
	"./mco.svg": 43190,
	"./mda.svg": 33997,
	"./mdg.svg": 68947,
	"./mdv.svg": 48978,
	"./mex.svg": 47959,
	"./mhl.svg": 22692,
	"./mkd.svg": 47989,
	"./mli.svg": 97549,
	"./mlt.svg": 13672,
	"./mmr.svg": 37957,
	"./mne.svg": 29711,
	"./mng.svg": 40157,
	"./mnp.svg": 21026,
	"./moz.svg": 12295,
	"./mrt.svg": 76906,
	"./msr.svg": 21251,
	"./mtq.svg": 52877,
	"./mus.svg": 70332,
	"./mwi.svg": 63948,
	"./mys.svg": 46211,
	"./myt.svg": 62383,
	"./nam.svg": 52453,
	"./ncl.svg": 50298,
	"./ner.svg": 66070,
	"./nfk.svg": 11014,
	"./nga.svg": 14851,
	"./nic.svg": 12859,
	"./nir.svg": 66842,
	"./niu.svg": 90373,
	"./nld.svg": 5187,
	"./nor.svg": 40072,
	"./npl.svg": 44023,
	"./nru.svg": 91508,
	"./nzl.svg": 66213,
	"./omn.svg": 61039,
	"./pak.svg": 60289,
	"./pan.svg": 34908,
	"./pcn.svg": 2090,
	"./per.svg": 28148,
	"./phl.svg": 22393,
	"./plw.svg": 22198,
	"./png.svg": 268,
	"./pol.svg": 72436,
	"./pri.svg": 79446,
	"./prk.svg": 95060,
	"./prt.svg": 33523,
	"./pry.svg": 50566,
	"./pse.svg": 1137,
	"./pyf.svg": 67676,
	"./qat.svg": 67859,
	"./reu.svg": 52573,
	"./rou.svg": 54155,
	"./rus.svg": 3923,
	"./rwa.svg": 58159,
	"./sau.svg": 56948,
	"./sco.svg": 83076,
	"./sdn.svg": 68388,
	"./sen.svg": 35707,
	"./sgp.svg": 69127,
	"./sgs.svg": 81268,
	"./shn.svg": 18912,
	"./sjm.svg": 50157,
	"./slb.svg": 10504,
	"./sle.svg": 12903,
	"./slv.svg": 6308,
	"./smr.svg": 1543,
	"./som.svg": 32442,
	"./spm.svg": 12555,
	"./srb.svg": 62402,
	"./ssd.svg": 18671,
	"./stp.svg": 72002,
	"./sun.svg": 55339,
	"./sur.svg": 61423,
	"./svk.svg": 6815,
	"./svn.svg": 56514,
	"./swe.svg": 36554,
	"./swz.svg": 74317,
	"./sxm.svg": 98307,
	"./syc.svg": 32050,
	"./syr.svg": 52019,
	"./tca.svg": 4641,
	"./tcd.svg": 55964,
	"./tgo.svg": 74403,
	"./tha.svg": 50112,
	"./tjk.svg": 74928,
	"./tkl.svg": 42028,
	"./tkm.svg": 77485,
	"./tls.svg": 58710,
	"./ton.svg": 46346,
	"./tto.svg": 98138,
	"./tun.svg": 37300,
	"./tur.svg": 97536,
	"./tuv.svg": 68044,
	"./twn.svg": 44770,
	"./tza.svg": 19514,
	"./uga.svg": 99468,
	"./ukr.svg": 19,
	"./umi.svg": 46358,
	"./ury.svg": 4823,
	"./usa.svg": 4280,
	"./uzb.svg": 71300,
	"./vat.svg": 87956,
	"./vct.svg": 73578,
	"./ven.svg": 50314,
	"./vgb.svg": 35464,
	"./vir.svg": 52674,
	"./vnm.svg": 45128,
	"./vut.svg": 51664,
	"./wal.svg": 49193,
	"./wlf.svg": 46376,
	"./wsm.svg": 78210,
	"./xkx.svg": 2308,
	"./yem.svg": 31030,
	"./zaf.svg": 83762,
	"./zmb.svg": 87730,
	"./zwe.svg": 52603
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 93709;